import { Button, makeStyles, Title2, Tooltip } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
    partnersSection: {
        padding: "4rem 0",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    textCenter: {
        textAlign: "center",
        maxWidth: "800px",
        marginBottom: "3rem",
        padding: "0 1rem"
    },
    sectionTitle: {
        fontSize: "2rem",
        fontWeight: 400,
        color: "#333",
        lineHeight: 1.3
    },
    partnerLogos: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "2rem",
        marginTop: "1rem",

        "& img": {
            maxWidth: "100%",
            height: "auto",
            maxHeight: "96px",
            objectFit: "contain",
            transition: "filter 1s ease",
            
            "&:hover": {
                filter: "grayscale(80%)"
            },

            "@media (max-width: 575px)": {
                maxHeight: "60px"
            }
        }
    },
    partnerLogo: {
        flex: "1 1 calc(20% - 2rem)",
        maxWidth: "calc(20% - 2rem)",
        boxSizing: "border-box",
        textAlign: "center",

        "@media (max-width: 575px)": {
            flex: "1 1 calc(50% - 2rem)",
            maxWidth: "calc(50% - 2rem)"
        }
    }
});

interface IPartnerLogoProps {
    logoPath: string;
    name: string;
}

const PartnerLogo = (props: IPartnerLogoProps) => {
    const { logoPath, name } = props;
    const styles = useStyles();

    return (
        <div className={styles.partnerLogo}>
            <Tooltip content={name} relationship="label">
                <img src={logoPath} alt={name} />
            </Tooltip>
        </div>
    );
};

export default function Partners() {
    const { t } = useTranslation("ourstory");
    const styles = useStyles();

    return (
        <section className={styles.partnersSection}>
            <div className={styles.textCenter}>
                <Title2 block as="h2" className={styles.sectionTitle}>
                    <span dangerouslySetInnerHTML={{ __html: t("partners.title") }} />
                </Title2>
            </div>
            <div className={styles.partnerLogos}>
                <PartnerLogo logoPath="/img/logos/microsoft-logo.png" name="Microsoft" />
                <PartnerLogo logoPath="/img/logos/webcon-logo.png" name="WEBCON" />
                <PartnerLogo logoPath="/img/logos/opentext-logo.svg" name="OpenText" />
                <PartnerLogo logoPath="/img/logos/pax8-logo.png" name="Pax8" />
            </div>
            <Link to="/partners">
                <Button appearance="primary" size="large" style={{ marginTop: "2rem" }}>
                    {t("partners.btnSeeAll")}
                </Button>
            </Link>
        </section>
    );
}